import apiClient from "../config/apiClient";


export const fetchPatientBills = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=patient/${id}/transactions/portal`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  

//   /public/portal?url=patient/${id}/transactions?page=1&limit=12&startDate=&endDate=&status=&service_id=&token=${token}